const normalizeHost = (value?: string | null): string | null => {
  if (!value) {
    return null
  }

  return value
    .replace(/^https?:\/\//, '')
    .split('/')[0]
    ?.split(':')[0]
    ?.trim()
    ?.toLowerCase()
}

export const isSystemeDomain = (domainName?: string | null): boolean => {
  const domainHost = normalizeHost(domainName)
  const systemeHost = normalizeHost(process.env.SYSTEME_IO_HOST)

  if (!domainHost || !systemeHost) {
    return false
  }

  return domainHost === systemeHost || domainHost.endsWith(`.${systemeHost}`)
}
